import type {
  PatientPrivateOnboard,
  PatientPrivateOnboardRequest,
} from '@quromedical/models';
import { router } from 'expo-router';
import { PatientOnboardApi } from 'integration/aggregate';
import type { OnboardStackScreenProps } from 'navigation';
import type React from 'react';
import { useCallback } from 'react';
import { ScrollView } from 'react-native';
import { trpcClient } from 'trpc';

import { PrivateOnboardForm } from './forms';
import { NavigationToggle } from './navigation';

const api = new PatientOnboardApi();

export const OnboardPrivateScreen: React.FC<
  OnboardStackScreenProps<'Private'>
> = () => {
  const handlePrivatePatient = useCallback(
    async (patient: PatientPrivateOnboardRequest) => {
      const result = await api.onboardPrivate(patient);

      // navigate to the page for the created patient on completion
      const id = result.patientId;
      if (!id) return;

      router.push(`/patient/${id}/profile`);
    },
    [],
  );

  const handlePrivatePatientUpdate = useCallback(
    async (patient: PatientPrivateOnboard) => {
      const result =
        await trpcClient.patient.updatePrivatePatient.mutate(patient);

      // navigate to the page for the created patient on completion
      const id = result.patientId;
      if (!id) return;

      router.push(`/patient/${id}/clinical`);
    },
    [],
  );

  return (
    <ScrollView>
      <NavigationToggle active="Private" />

      <PrivateOnboardForm
        onSubmit={handlePrivatePatient}
        onUpdate={handlePrivatePatientUpdate}
      />
    </ScrollView>
  );
};
